<template>
  <v-container fluid tag="section">
    <v-row justify="center">
      <v-col>
        <base-material-card color="primary" icon="mdi-office-building-outline" inline class="ml-0 px-5 py-3">
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">Empresas</div>
          </template>

          <v-btn color="success" dark elevation="1" class="mt-5" style="float: left" relative text medium @click="addEmpresa">
            <v-icon left size="30px">mdi-plus-circle</v-icon>
            NOVA EMPRESA
          </v-btn>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="break-search bs-empresas ml-auto mt-4"
            label="Procurar"
            hide-details
            single-line
            style="max-width: 250px"
          />

          <v-divider class="mt-10" />

          <v-data-table
            class="empresas-table"
            :headers="headers"
            :options="options"
            :items="empresas"
            :search.sync="search"
            :header-props="{
              sortByText: 'Ordenar Por'
            }"
            :footer-props="{
              itemsPerPageText: 'Itens por Página'
            }"
            no-data-text="Nenhuma empresa disponível"
            no-results-text="Nenhum registro correspondente encontrado"
            mobile-breakpoint="800"
          >
            <template v-slot:[`item.nome`]="{ item }">
              {{ item.nome }}
            </template>
            <template v-slot:[`item.sigla`]="{ item }">
              {{ item.sigla }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="blue-grey lighten-3" class="ml-1 px-2" min-width="0" small v-bind="attrs" v-on="on">
                    <v-icon small>mdi-menu-down-outline</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="editarEmpresa(item.id)">
                    <v-list-item-title>
                      <v-icon small>mdi-pencil</v-icon>
                      Editar
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="openDialogDelete(item.id, item.nome)">
                    <v-list-item-title>
                      <v-icon small>mdi-trash-can-outline</v-icon>
                      Deletar
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="deletarEmpresa(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Empresa</template>
      <template slot="body">
        Tem certeza que deseja deletar a empresa
        <strong>{{ dialogDeleteData.nome }}</strong>
        ?
      </template>
    </dialog-delete>
  </v-container>
</template>

<script>
  import Firestore from '@/Firestore.js';

  export default {
    name: 'Empresas',

    components: {
      DialogDelete: () => import('@/components/general/DialogDelete')
    },

    data: () => ({
      empresas: [],
      search: undefined,
      headers: [
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Sigla',
          value: 'sigla'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-3'
        }
      ],
      options: {
        sortBy: ['nome'],
        multiSort: false
      },
      dialogDelete: false,
      dialogDeleteData: { id: undefined, nome: undefined }
    }),

    mounted() {
      this.getEmpresas();
    },

    methods: {
      getEmpresas() {
        this.empresas = [];

        Firestore.collection('empresas')
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.empresas.push({
                id: doc.id,
                nome: doc.data().nome,
                sigla: doc.data().sigla
              });
            });
          });
      },

      editarEmpresa(id) {
        this.$router.push('/administracao/empresas/edit/' + id);
      },

      addEmpresa() {
        this.$router.push('/administracao/empresas/edit/');
      },

      async deletarEmpresa(id) {
        const empRef = await Firestore.collection('empresas').doc(id);

        Firestore.collection('empresas')
          .doc(id)
          .delete()
          .then(() => {
            this.deletaUsuariosEmpresa(empRef);
            this.$toast.success('Empresa excluida com sucesso.', '', { position: 'topRight' });
            this.getEmpresas();
          })
          .catch((error) => {
            this.$toast.error('Erro ao excluir empresa.', '', {
              position: 'topRight'
            });
            console.error('Erro ao excluir empresa, error:', error);
          });
        this.dialogDelete = false;
      },

      deletaUsuariosEmpresa(empRef) {
        Firestore.collection('usuarios_empresas')
          .where('empresa_id', '==', empRef)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              Firestore.collection('usuarios_empresas')
                .doc(doc.id)
                .delete()
                .catch((error) => {
                  console.error('Erro ao remover usuários ligados a empresa, error:', error);
                });
            });
          });
      },

      openDialogDelete(id, nome) {
        this.dialogDeleteData = { id: id, nome: nome };
        this.dialogDelete = true;
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .empresas-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .empresas-table table tr td:nth-child(2),
    .empresas-table table tr td:nth-child(3) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-empresas {
      width: 181.16px !important;
    }
  }
</style>